import React, {useContext, useEffect, useRef} from 'react'
import {useParams} from "react-router";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import {connect} from "react-redux";
import scrollTo from "libs/scrollTo";
import GeneralInfoEntry from "../generalInfo/components/GeneralInfoEntry";
import Tr from 'translations/Translations'
import {ContractorOfferEspdType} from "constants/ContractorOfferEspdType";
import {makeStyles} from "@material-ui/core";
import {StageSectionsUrlParams} from "../../../constants/StageSections";
import {OfferMode} from "../../common/constants/OfferMode";
import OfferSectionContext from "context/OfferSectionContext";
import OfferPositions from "../offerEdit/components/positions/OfferPositions";
import OfferEspd from "../offerEdit/components/espd/OfferEspd";
import OfferFiles from "../offerEdit/components/files/OfferFiles";
import OfferContractorData from "../../common/contractorData/OfferContractorData";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import DemandOffersAuctionService from "services/DemandOffersAuctionService";
import AdditionalOfferCommonData from "../additionalOfferEdit/components/commonData/AdditionalOfferCommonData";
import {RoundType} from "constants/RoundType";
import HelpTooltip from "components/HelpTooltip";
import OfferStageTranslationsContext from "context/OfferStageTranslationsContext";

const useStyle = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    floatingMenu: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        bottom: 0,
        marginTop: theme.spacing()
    },
    menuBarPaper: {
        background: theme.palette.background.default,
        border: `solid 1px ${theme.palette.border.dark}`,
    },
    marginLeft: {
        marginLeft: theme.spacing(2)
    }
}))

function AuctionOfferPlacedPanel(
    {
        panelRef,
        demandHeader,
        offerEdit,
        formSubmit,
        formValues
    }) {

    const classes = useStyle();
    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const section = params.section;
    const mode = section === StageSectionsUrlParams.ADDITIONAL_OFFER_EDIT ? OfferMode.EDIT : OfferMode.PLACED;
    const contextSection = useContext(OfferSectionContext);
    const stageTr = useContext(OfferStageTranslationsContext);
    const purchaserOfferContext = useContext(PurchaserOfferContext)
    const disabled = offerEdit ? offerEdit.disabled : true;
    const dataLoading = !offerEdit || !demandHeader;
    const positionsRef = useRef();

    useEffect(() => {
            if (!dataLoading) {
                setTimeout((elem) => scrollTo(elem), 100, panelRef.current);
            }
        }
        // eslint-disable-next-line
        , [dataLoading])

    useEffect(() => {
        DemandOffersAuctionService.getOfferEdit(demandId, stageId, mode, purchaserOfferContext?.supplierId);
        return () => {
            DemandOffersAuctionService.clearResources(DemandOffersAuctionService.AUCTIONS_OFFER_EDIT);
        }
        // eslint-disable-next-line
    }, [demandId, stageId, section])


    return dataLoading ? <Loading/> : offerEdit.positions.length > 0 &&
        <div className={classes.root}>
            <GridBlock column>

                <GeneralInfoEntry biggerLabel label={Tr('contractor_data')}>
                    <OfferContractorData offerEdit={offerEdit}/>
                </GeneralInfoEntry>

                <GeneralInfoEntry biggerLabel label={Tr('contractor_company_data')}>
                    <AdditionalOfferCommonData section={contextSection} offerEdit={offerEdit}/>
                </GeneralInfoEntry>

                {
                    offerEdit.offerEspdType !== ContractorOfferEspdType.NO &&
                    <GeneralInfoEntry biggerLabel label={Tr('jedz_full')}>
                        <OfferEspd roundType={RoundType.AUCTION} mode={mode} disabled offerEdit={offerEdit} section={contextSection} />
                    </GeneralInfoEntry>
                }

                <GeneralInfoEntry biggerLabel label={<>
                    {stageTr("offer_documents")}
                    { (offerEdit.passiveOfferForm || contextSection.digitalSign) && <HelpTooltip className={classes.marginLeft} dangerouslySetTextHTML={Tr("offer_documents_signature_tooltip_html")} />}
                </>}>
                    <OfferFiles roundType={RoundType.AUCTION} mode={mode} disabled offerEdit={offerEdit} section={contextSection}/>
                </GeneralInfoEntry>

                {!offerEdit.passiveOfferForm &&
                    <OfferPositions roundType={RoundType.AUCTION} positionsRef={positionsRef} offerEdit={offerEdit} mode={mode} disabled={disabled}/>
                }

            </GridBlock>

        </div>
}

AuctionOfferPlacedPanel.propTypes = {}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    offerEdit: state.resources[DemandOffersAuctionService.AUCTIONS_OFFER_EDIT],
    formSubmit: state.form,
    formValues: state.formValues
}), {})(AuctionOfferPlacedPanel);